import {
  AppService,
  ManifestService,
  ProService,
} from '../services/orphan.service.js';
import PrintService from '../services/print.service.js';

const initialState = {
  _activePro: null,
  _pros: [],
  _segments: [],
  _statuses: [],
  _workflows: [
    { name: "B2B Direct" },
    { name: "B2B Agent" },
    { name: "B2B Will Call" },
    { name: "B2C Direct WGI" },
    { name: "B2C Direct WGNI" },
    { name: "B2C Direct THR" },
    { name: "B2C Will Call WGI" },
    { name: "B2C Will Call WGNI" },
    { name: "B2C Will Call THR" },
    { name: "B2C Agent WGI" },
    { name: "B2C Agent WGNI" },
    { name: "B2C Agent THR" },
    { name: "4PL RETURN DIRECT" },
    { name: "4PL AGENT RECOVERY" },
    { name: "STANDARD" },
    { name: "MIL Direct" },
    { name: "MIL Agent" },
    { name: "CON Direct" },
    { name: "CON Agent" },
  ],
  _totalRecords: 0,
  _page: 1,
};

const createStore = () => {
  return {
    namespaced: true,
    state: initialState,
    getters: {
      activePro: (state) => state._activePro,
      pros: (state) => state._pros,
      segments: (state) => state._segments,
      statuses: (state) => state._statuses,
      workflows: (state) => state._workflows,
      totalRecords: (state) => state._totalRecords,
      page: (state) => state._page,
      size: (state) => state._pros.length,
      client: (state, getters, rootState) => {
        return ProService.getInstance(rootState.auth.user.token);
      },
      manifestClient: (state, getters, rootState) => {
        return ManifestService.getInstance(rootState.auth.user.token);
      },
      appClient: (state, getters, rootState) => {
        return AppService.getInstance(rootState.auth.user.token);
      },
      printClient: (state, getters, rootState) => {
        return new PrintService(rootState.auth.user.token);
      },
    },
    actions: {
      getPro: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .proGet(params.proNumber, true)
          .then((data) => {
            console.log('SET_ACTIVE_PRO', data);
            commit('SET_ACTIVE_PRO', data.result);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
            throw error;
          });
      },
      unvoidPro: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .unvoidPro(params.proNumber, { proNumber: params.proNumber })
          .then(() => {
            dispatch('toast/success', `Pro ${params.proNumber} unvoided`, { root: true });
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            } else if (error.status == 400) {
              // 400 = ProNotVoided guard: the pro is already InProcess, so the unvoid
              // already took effect. Treat a redundant call as benign, not a failure.
              dispatch('toast/success', `Pro ${params.proNumber} is already unvoided`, { root: true });
              return;
            } else {
              dispatch('toast/error', `Failed to unvoid pro ${params.proNumber}`, { root: true });
            }
            return Promise.reject(error);
          });
      },
      getActivePros: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        client
          .activeProFilteredList(params.lazyParams)
          .then((response) => {
            const data = response.result;
            console.log('store - pros', data);
            commit('SET_PROS', data.result);
            commit('SET_TOTAL_RECORDS', data.count);
            commit('SET_PAGE', data.page);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      getPros: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        client
          .getPros(params.lazyParams)
          .then((response) => {
            const data = response.result;
            console.log('store - pros', data);
            commit('SET_PROS', data.result);
            commit('SET_TOTAL_RECORDS', data.count);
            commit('SET_PAGE', data.page);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      getProStatuses: ({ commit, getters, dispatch }) => {
        const client = getters.client;
        return client
          .proStatusesGet()
          .then((data) => {
            console.log('SET_STATUSES', data);
            commit('SET_STATUSES', data.result);
            // Cache the result
            localStorage.setItem('proStatuses', JSON.stringify(data.result));
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      getSegments: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .proSegments(params.proNumber)
          .then((data) => {
            console.log('SET_SEGMENTS', data);
            commit('SET_SEGMENTS', data.result);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      getAvailableLinehaulPros: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        client
          .availableLinehaulPros(params.terminal, params.lazyParams)
          .then((response) => {
            const data = response.result;
            console.log('store - availableLinehaulPros', data);
            commit('SET_PROS', data.result);
            commit('SET_TOTAL_RECORDS', data.count);
            commit('SET_PAGE', data.page);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      getAvailableDeliveryPros: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        client
          .availableDeliveryPros(params.terminal, params.lazyParams)
          .then((response) => {
            const data = response.result;
            console.log('store - availableDeliveryPros', data);
            commit('SET_PROS', data.result);
            commit('SET_TOTAL_RECORDS', data.count);
            commit('SET_PAGE', data.page);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      getAvailablePickups: ({ commit, getters, dispatch }, params) => {
        const client = getters.client;
        client
          .availablePickupPros(params.trailer, params.lazyParams)
          .then((response) => {
            const data = response.result;
            console.log('store - getAvailablePickups', data);
            commit('SET_PROS', data.result);
            commit('SET_TOTAL_RECORDS', data.count);
            commit('SET_PAGE', data.page);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      updateAppointment: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .updateAppointment(params.proNumber, params.appointment)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      schedulePickup: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .schedulePickup(params.proNumber, params.pickup)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      printLabels: ({ getters, dispatch }, params) => {
        const printClient = getters.printClient;
        return printClient
          .printProLabels(params.proNumber)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      assignPickups: ({ getters, dispatch }, params) => {
        const client = getters.manifestClient;
        return client
            .assignPickups(params.manifestId, params.selectedPros)
            .then((response) => {
              // BBatts: assignPickups returns a plain boolean, not an ApiResultResponse.
              if (response !== true) throw new Error("Pickup assignment failed.");
              // Return a success flag so callers can react to the result
              return true;
            })
            .catch((error) => {
               console.log('ERROR!', error);
              if (error.isError && error.status == 401) {
                dispatch('auth/logout', {}, { root: true });
              }
             if (error.isError) throw new Error(error.title);
             // Re-throw so callers can handle the error
             throw error;
            });
      },
      assignPros: ({ getters, dispatch }, params) => {
        const client = getters.manifestClient;
        return client
          .assignPros(params.manifestId, params.selectedPros)
          .then((response) => {
            // The assignpros endpoint returns a plain boolean, not an
            // ApiResultResponse — checking .isSuccess on a boolean was always
            // undefined, so this threw even when the assignment succeeded
            // (false "Pro Assigned Failed" toast, Details tab never refreshed).
            if (response !== true) throw new Error("Pro assignment failed.");
            return true;
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
            if (error.isError) throw new Error(error.title);
            // Re-throw so callers can handle the error
            throw error;
          });
      },
      unassignPros: ({ getters, dispatch }, params) => {
        const client = getters.manifestClient;
        return client
          .unassignPros(params.manifestId, params.selectedPros)
          .then((response) => {
            if (!response.isSuccess) throw new Error(response.failureReason);
            return true;
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
            if (error.isError) throw new Error(error.title);
            // Re-throw so callers can handle the error
            throw error;
          });
      },
      pullPro: ({ getters, dispatch }, params) => {
        const client = getters.manifestClient;
        return client
          .pullPro(params.manifestId, params.proNumber, params)
          .then((response) => {
            console.log(response);
            if (!response.isSuccess) throw new Error(response.failureReason);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
            if (error.isError) throw new Error(error.title);
          });
      },
      refreshLane: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .refeshLane(params.proNumber)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      scanTrackingUnit: ({ getters, dispatch }, params) => {
        const client = getters.appClient;
        return client
          .scanTrackingUnit(params.proNumber, params.barcode, params.state)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      deactivateTrackingUnit: ({ getters, dispatch }, params) => {
        const client = getters.appClient;
        return client
          .deactivateTrackingUnit(params)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      activateTrackingUnit: ({ getters, dispatch }, params) => {
        const client = getters.appClient;
        return client
          .activateTrackingUnit(params)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },
      relocateItem: ({ getters, dispatch }, params) => {
        const client = getters.appClient;
        return client
          .relocateItemV2(params)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      relocatePro: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .relocatePro(params)
          .then((response) => {
            console.log(response);
            dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      archivePro: ({ getters, dispatch }, proNumber) => {
        const client = getters.client;
        return client
          .archivePro(proNumber)
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      /**
       * Split a pro into multiple pros based on the line item barcodes.
       * @param {Object} params
       * @param {string} params.proNumber - The PRO number to split.
       * @param {string[]} params.lineItemBarcodes - The line item barcodes to split by.
       * @returns {Promise} Resolves with the response from the server. Rejects with an error if there was a problem.
       */
      splitPro: ({ getters, dispatch }, params) => {
        const client = getters.client;
        return client
          .splitPro(params.proNumber, {
            proNumber: params.proNumber,
            lineItemBarcodes: params.lineItemBarcodes,
          })
          .then((response) => {
            console.log(response);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            dispatch('toast/error', 'Failed to split pro', { root: true });
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            }
          });
      },

      updateActiveTerminal: ({ getters, dispatch }, params) => {
        const client = getters.client;
        // ProClient exposes this as proUpdateActiveTerminal (NSwag names it from the swagger
        // operationId) and it takes the ProTerminalUpdateDto as the body, not a route id.
        return client
          .proUpdateActiveTerminal({
            proNumber: params.proNumber,
            terminal: params.terminal,
          })
          .then(() => {
            return dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            } else {
              dispatch('toast/error', 'Failed to update active terminal', { root: true });
            }
            return Promise.reject(error);
          });
      },
      updateOriginTerminal: ({ getters, dispatch }, params) => {
        const client = getters.client;
        // ProClient exposes this as proUpdateOriginTerminal (NSwag names it from the swagger
        // operationId) and it takes the ProTerminalUpdateDto as the body, not a route id.
        return client
          .proUpdateOriginTerminal({
            proNumber: params.proNumber,
            terminal: params.terminal,
          })
          .then(() => {
            return dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            } else {
              dispatch('toast/error', 'Failed to update origin terminal', { root: true });
            }
            return Promise.reject(error);
          });
      },
      updateDestinationTerminal: ({ getters, dispatch }, params) => {
        const client = getters.client;
        // ProClient exposes this as proUpdateDestinationTerminal (NSwag names it from the swagger
        // operationId) and it takes the ProTerminalUpdateDto as the body, not a route id.
        return client
          .proUpdateDestinationTerminal({
            proNumber: params.proNumber,
            terminal: params.terminal,
          })
          .then(() => {
            return dispatch('getPro', params);
          })
          .catch((error) => {
            console.log('ERROR!', error);
            if (error.isError && error.status == 401) {
              dispatch('auth/logout', {}, { root: true });
            } else {
              dispatch('toast/error', 'Failed to update destination terminal', { root: true });
            }
            return Promise.reject(error);
          });
      },
    },
    mutations: {
      SET_ACTIVE_PRO(state, data) {
        state._activePro = data;
      },
      SET_SEGMENTS(state, data) {
        state._segments = data;
      },
      SET_STATUSES(state, data) {
        state._statuses = data;
      },
      SET_PROS(state, data) {
        if (data == null || data.length == 0) return [];
        state._pros = data.map((x) => {
          return {
            proNumber: x.proNumber,
            age: x.age,
            created: new Date(x.created),
            alert: 'TBD',
            expo: 'TBD',
            type: 'WG-TBD',
            appt: x.appointment,
            lane: x.lane,
            wflow: x.workflow,
            status: x.status,
            activeTemplate: 'P-TBD',
            currenManifest: x.currentManifest,
            currentLocation: 'TBD',
            assignedLocation: 'TBD',
            activeTerminal: x.activeTerminal,
            originTerminal: x.originTerminal,
            destinationTerminal: x.destinationTerminal,
            carrierConsignee: x.carrierConsignee?.name,
            carrierConsigneeCity: x.carrierConsignee?.address?.city,
            carrierConsigneeState: x.carrierConsignee?.address?.state,
            carrierConsigneePostalCode: x.carrierConsignee?.address?.postalCode,
            revenue: x.revenue,
            units: x.units,
            weight: x.weight,
            cubes: x.cubes,
            seats: x.seats,
            specialInstructions: 'TBD', //add to shipper
            shipper: x.shipper?.name,
            shipperCity: x.shipper?.address?.city,
            shipperState: x.shipper?.address?.state,
            shipperPostalCode: x.shipper?.address?.postalCode,
            shipperConsignee: x.shipperConsignee?.name,
            shipperConsigneeCity: x.shipperConsignee?.address?.city,
            shipperConsigneeState: x.shipperConsignee?.address?.state,
            shipperConsigneePostalCode: x.shipperConsignee?.address?.postalCode,
            packTypes: x.packTypes,
          };
        });
      },
      SET_TOTAL_RECORDS(state, data) {
        state._totalRecords = data;
      },
      SET_PAGE(state, data) {
        state._page = data;
      },
    },
  };
};

export default (app) => createStore(app);
